export function prepareRoutes(routes) {
  const output = [];

  routes.forEach(route => {
    if (route.children && route.children.length > 0) {
      route.children = prepareRoutes(route.children);
    }

    // Add /detail to detail routes
    if (route.name.indexOf('-id') !== -1) {
      route.path = `${route.path}/detail`;
    }

    // Remove name from routes with default children
    if (route.children && route.children.length > 0) {
      const found = route.children.find(
        child => child.name === `${route.name}-index`,
      );
      if (found) {
        delete route['name'];
      }
    }

    output.push(route);
  });

  return output;
}
